
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wzkrmmyduiqvzvoxfvxy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind6a3JtbXlkdWlxdnp2b3hmdnh5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc2NjQwMDIsImV4cCI6MjA1MzI0MDAwMn0.-hzW7XFX13OaatpGdpZO3IVE3FlC_gCT0xYq0cIYNR0";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
    storage: typeof window !== 'undefined' ? window.localStorage : undefined
  }
});
